import type {ReactElement} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {noop} from '@Utils/general.util';
import {assertNever} from '@Utils/assert-never.util';
import type {StockMediaFilterPillProps} from './stock-media-filter-pill.types';
import {StockMediaFilterPillType} from './stock-media-filter-pill.types';
import styles from './stock-media-filter-pill.module.scss';

export function StockMediaFilterPill(props: StockMediaFilterPillProps): ReactElement {
  const getClassName = (isActive?: boolean): string => {
    return [
      styles.pill,
      props.isSelected ? styles.appliedFilter : '',
      isActive ? styles.active : '',
      '_cursor-pointer hover-transition-all radius-round flex-center gap-1 spacing-p-r-3 spacing-p-l-3 spacing-p-b-0',
    ]
      .filter(Boolean)
      .join(' ');
  };

  switch (props.type) {
    case StockMediaFilterPillType.DROPDOWN_SELECTOR:
      return (
        <ClickableDiv className={getClassName(props.isActive)} onClick={props.onClick ?? noop}>
          {props.children}
        </ClickableDiv>
      );
    case StockMediaFilterPillType.LIST_ITEM:
      return (
        <li className={getClassName()} onClick={props.onClick}>
          {props.children}
        </li>
      );
    default:
      return assertNever(props);
  }
}
